import { queryParameters,fetchJson } from './utils';
import {
    GET_LIST,
    GET_ONE,
    GET_MANY,
    GET_MANY_REFERENCE,
    CREATE,
    UPDATE,
    DELETE,
} from 'admin-on-rest';

/**
 * Maps admin-on-rest queries to a simple REST API
 *
 * The REST dialect is similar to the one of FakeRest
 * @see https://github.com/marmelab/FakeRest
 * @example
 * GET_LIST     => GET http://my.api.url/posts?sort=['title','ASC']&range=[0, 24]
 * GET_ONE      => GET http://my.api.url/posts/123
 * GET_MANY     => GET http://my.api.url/posts?filter={ids:[123,456,789]}
 * UPDATE       => PUT http://my.api.url/posts/123
 * CREATE       => POST http://my.api.url/posts/123
 * DELETE       => DELETE http://my.api.url/posts/123
 */
export default (apiUrl, httpClient = fetchJson) => {
    /**
     * @param {String} type One of the constants appearing at the top if this file, e.g. 'UPDATE'
     * @param {String} resource Name of the resource to fetch, e.g. 'posts'
     * @param {Object} params The REST request params, depending on the type
     * @returns {Object} { url, options } The HTTP request parameters
     */
    const convertRESTRequestToHTTP = (type, resource, params) => {
        let url = '';
        const options = {};

        var auth_token = localStorage.getItem('auth_token');

        switch (type) {
        case GET_LIST: {
            const { page, perPage } = params.pagination;
            let { field, order } = params.sort;
            order = order === 'ASC' ? 1 : -1;
            if (params.filter.title !== undefined) {
              params.filter.title = { $regex: params.filter.title, $options: 'i'};
              console.log(params.filter.title);
            } else if (params.filter.name !== undefined){
              params.filter.name = { $regex: params.filter.name, $options: 'i'};
            }
            auth_token = localStorage.getItem('auth_token');
            const query = {
                // sort: `{ ${field}: ${order}}`,
                field,
                order,
                range: JSON.stringify([(page - 1) * perPage, (page * perPage) - 1]),
                page: page,
                per_page: perPage,
                filters: JSON.stringify(params.filter),
                token:auth_token,
            };
            url = `${apiUrl}/${resource}?${queryParameters(query)}`;
            break;
        }
        case GET_ONE:
        auth_token = localStorage.getItem('auth_token');
        const query = {token:auth_token};
        url = `${apiUrl}/${resource}/${params.id}?${queryParameters(query)}`;
        console.log("GET_ONE",url);
            break;
        case GET_MANY: {
            auth_token = localStorage.getItem('auth_token');
            const query = {
                filter: JSON.stringify({ id: params.ids }),
            };
            url = `${apiUrl}/${resource}?${queryParameters(query)}`;
            console.log(url);
            break;
        }
        case GET_MANY_REFERENCE: {
            auth_token = localStorage.getItem('auth_token');
            const { page, perPage } = params.pagination;
            const { field, order } = params.sort;
            const query = {
                sort: JSON.stringify([field, order]),
                range: JSON.stringify([(page - 1) * perPage, (page * perPage) - 1]),
                filter: JSON.stringify({ ...params.filter, [params.target]: params.id }),
                token:auth_token
            };
            url = `${apiUrl}/${resource}?${queryParameters(query)}`;
            console.log(url);
            break;
        }
        case UPDATE:
          auth_token = localStorage.getItem('auth_token');
          var token_query = {token:auth_token};
          url = `${apiUrl}/${resource}/${params.id}?${queryParameters(token_query)}`;
            console.log("console.log(url);",url);
            options.method = 'PUT';
            options.body = JSON.stringify(params.data);
            break;
        case CREATE:
                       auth_token = localStorage.getItem('auth_token');
                       token_query = {token:auth_token};
                       url = `${apiUrl}/${resource}?${queryParameters(token_query)}`;
                       console.log(url);
                       options.method = 'POST';
                       params.data.token=auth_token;
                       console.log("params.data",params.data);
                       options.body = JSON.stringify(params.data);
                       break;
        case DELETE:
            auth_token = localStorage.getItem('auth_token');
            token_query = {token:auth_token};
            url = `${apiUrl}/${resource}/${params.id}?${queryParameters(token_query)}`;
            console.log(url);
            options.method = 'DELETE';
            break;
        default:
            throw new Error(`Unsupported fetch action type ${type}`);
        }
        return { url, options };
    };

    /**
     * @param {Object} response HTTP response from fetch()
     * @param {String} type One of the constants appearing at the top if this file, e.g. 'UPDATE'
     * @param {String} resource Name of the resource to fetch, e.g. 'posts'
     * @param {Object} params The REST request params, depending on the type
     * @returns {Object} REST response
     */
    const convertHTTPResponseToREST = (response, type, resource, params) => {
        const { headers, json } = response;
        switch (type) {
        case GET_LIST:
        case GET_MANY_REFERENCE:
            if (!headers.has('content-range')) {
                throw new Error('The Content-Range header is missing in the HTTP Response. The simple REST client expects responses for lists of resources to contain this header with the total number of results to build the pagination. If you are using CORS, did you declare Content-Range in the Access-Control-Expose-Headers header?');
            }
            console.log(json);
            const data = json.data.map((item) => {
              item.id = item._id;
              return item;
            });
            return {
                data,
                total: parseInt(headers.get('content-range').split('/').pop(), 10),
                // total: 10,
            };
        case CREATE:
            return { data: { ...params.data, id: json.id } };
        default:
            return { data: json };
        }
    };

    /**
     * @param {string} type Request type, e.g GET_LIST
     * @param {string} resource Resource name, e.g. "posts"
     * @param {Object} payload Request parameters. Depends on the request type
     * @returns {Promise} the Promise for a REST response
     */
    return (type, resource, params) => {
        const { url, options } = convertRESTRequestToHTTP(type, resource, params);
        return httpClient(url, options)
            .then(response => convertHTTPResponseToREST(response, type, resource, params));
    };
};



// WEBPACK FOOTER //
// ./src/restClient.js